import { render, staticRenderFns } from "./TermOfUse.vue?vue&type=template&id=4bf8dd0e"
import script from "./TermOfUse.vue?vue&type=script&lang=js"
export * from "./TermOfUse.vue?vue&type=script&lang=js"
import style0 from "./TermOfUse.vue?vue&type=style&index=0&id=4bf8dd0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports